import { useId, useMemo } from "react";

import { cn } from "@/lib/utils";

function AccessibilityIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-7.5 w-5.5", className)}
      fill="none"
      viewBox="0 0 22 30"
      {...props}
    >
      <g clipPath={`url(#${id}a)`}>
        <mask
          height="6"
          id={`${id}b`}
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="7"
          x="7"
          y="0"
        >
          <path
            d="M10.667 6a2.889 2.889 0 100-5.778 2.889 2.889 0 000 5.778z"
            fill="#fff"
          />
        </mask>
        <g mask={`url(#${id}b)`}>
          <mask
            height="2872"
            id={`${id}c`}
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="501"
            x="-31"
            y="-1932"
          >
            <path d="M-30.666 940h499.999v-2872h-500V940z" fill="#fff" />
          </mask>
          <g mask={`url(#${id}c)`}>
            <path d="M1.111-6.444h19.111v19.111H1.112V-6.444z" fill="#eb297b" />
          </g>
        </g>
        <mask
          height="23"
          id={`${id}d`}
          maskUnits="userSpaceOnUse"
          style={{ maskType: "luminance" }}
          width="21"
          x="0"
          y="7"
        >
          <path
            d="M20.778 14.522c0-.707-.52-1.285-1.213-1.4a8.322 8.322 0 01-4.666-2.543l-1.863-2.065a2.795 2.795 0 00-.881-.65c-.015 0-.015-.015-.03-.015h-.014a2.826 2.826 0 00-1.805-.361c-1.474.173-2.528 1.502-2.528 2.99V19c0 1.59 1.3 2.89 2.889 2.89h7.222v5.777c0 .794.65 1.444 1.444 1.444.795 0 1.445-.65 1.445-1.444v-6.5c0-1.589-1.3-2.889-2.889-2.889h-4.333v-4.983c1.444 1.199 3.466 2.224 5.489 2.629a1.435 1.435 0 001.733-1.402zm-8.912 8.812a4.339 4.339 0 01-4.088 2.888 4.327 4.327 0 01-4.333-4.333c0-1.892 1.213-3.481 2.888-4.088v-2.99a7.223 7.223 0 108.523 8.523h-2.99z"
            fill="#fff"
          />
        </mask>
        <g mask={`url(#${id}d)`}>
          <mask
            height="2872"
            id={`${id}e`}
            maskUnits="userSpaceOnUse"
            style={{ maskType: "luminance" }}
            width="501"
            x="-31"
            y="-1932"
          >
            <path d="M-30.666 940h499.999v-2872h-500V940z" fill="#fff" />
          </mask>
          <g mask={`url(#${id}e)`}>
            <path d="M-6.11.796h33.555v34.981H-6.111V.796z" fill="#eb297b" />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id={`${id}a`}>
          <path d="M0 0h21.333v29.333H0z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
}

interface HandicapAccessibilityProps {
  className?: string;
  handicapAccessibility: string;
}

export default function HandicapAccessibility({
  className,
  handicapAccessibility,
}: HandicapAccessibilityProps) {
  const handicapText = useMemo(() => {
    const tmp = handicapAccessibility.trim();

    if (tmp.toLocaleUpperCase() === "NO") {
      return "This experience is not accessible.";
    }

    if (tmp.toLocaleUpperCase() === "YES") {
      return "This experience may be accessible. Contact to confirm.";
    }

    return tmp;
  }, [handicapAccessibility]);

  if (!handicapText) {
    return null;
  }

  return (
    <div
      className={cn(
        "rounded-[15px] bg-white/5 p-5 md:rounded-[20px] md:px-6",
        className
      )}
    >
      <p className="whitespace-pre-line">
        <AccessibilityIcon className="mr-2.5" />
        {handicapText}
      </p>
    </div>
  );
}
